import React from 'react';
import { STATUS } from 'constants/index';

export default function ListOfModels({models, getDetailsLink}) {
  const _getRowStyles = status => {
    if (status === STATUS.DEACTIVATED) return '__row_deactivated';

    return '__row_active';
  };

  return (
    <section className='scene_section'>
      <header className='_padding_bottom_20'>List of Models</header>
      {models.length !== 0 &&
      <section className='selected-list'>
        <div className='selected-list__header'>
          <div className='selected-list__header_text _width_pc_14'>ID</div>
          <div className='selected-list__header_text _width_pc_45'>Name</div>
          <div className='selected-list__header_text _width_pc_18'>
            {models[0].boatType ? 'Type' : ''}
          </div>
          <div className='selected-list__header_text _width_pc_18'>
            {models[0].engineType ? 'Engine Type' : ''}
          </div>
        </div>
        <div className='selected-list__body'>
          {models.map(model => {
            return (
              <a key={model.id} href={getDetailsLink(model)} target='_blank' rel="noreferrer">
                <div
                  key={model.id}
                  className={`selected-list__body_row ${_getRowStyles(model.status)}`}
                  style={{cursor: 'pointer'}}
                >
                  <div className='selected-list__body_text _width_pc_14'>{model.id}</div>
                  <div className='selected-list__body_text _width_pc_45'>{model.name}</div>
                  <div className='selected-list__body_text _width_pc_18'>
                    {model.boatType ? model.boatType.replace(/_/, ' ') : ''}
                  </div>
                  <div className='selected-list__body_text _width_pc_18'>
                    {model.engineType ? model.engineType.replace(/_/, ' ') : ''}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </section>}
    </section>
  );
}

ListOfModels.defaultProps = {
  models: [],
  selectedModelList: []
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Report/ListOfModels.jsx